export default "__VITE_ASSET__e08dc09d__"